export default __webpack_public_path__ + "static/media/EWallet_linked.d7daa3f3.svg";